<div class="radio-container" [formGroup]="form">
  <span
    class="radio-button {{ settings.className }}"
    *ngFor="let radio of settings.innerelements"
  >
    <input
      type="radio"
      [id]="radio.id"
      [value]="radio.value"
      [formControlName]="settings.formControlName"
      (change)="valueChange()"
      (focus)="onFocusEvent($event)"
      (click)="onClickEvent($event)"
      (blur)="onBlurEvent($event)"
      (change)="onKeyupEvent($event)"
    />
    <label [for]="radio.id">{{ radio.label }}</label>
  </span>
  <p class="text-danger">{{ errorMessage }}</p>
</div>
